import {
  createDateFilter,
  createTextFilter,
} from '../builder-definition/filters/table';
import {
  createCellActions,
  createCellLink,
  createCellPlainStatuses,
} from '../builder-definition/tables';
import {
  createCellUrl,
} from '../builder-definition/tables/plain-builders';

export default {
  headers: [
    {
      value: 'id',
      text: 'ID',
      name: 'id',
      width: '70px',
      hideable: false,
      isShown: true,
      customFilter: createTextFilter({ placeholder: 'Search ID' }),
      ...createCellPlainStatuses({
        mapper: 'privateOffers',
        statusProp: 'status',
      }),
    },
    {
      value: 'name',
      name: 'name',
      text: 'Name',
      width: '132px',
      sortable: false,
      isShown: true,
      customFilter: createTextFilter({ placeholder: 'Search name' }),
    },
    {
      value: 'slug',
      name: 'slug',
      text: 'Url',
      width: '132px',
      sortable: false,
      isShown: true,
      customFilter: createTextFilter({ placeholder: 'Search url' }),
      ...createCellUrl({
        useClientUrl: true,
        url: 'privateoffer',
      }),
    },
    {
      value: 'manager.email',
      text: 'Referral manager',
      name: 'manager.email',
      customFilter: createTextFilter({ placeholder: 'Search referral' }),
      ...createCellLink({
        to: (item) => ({
          name: 'ProfileUser',
          params: {
            id: item.manager?.id,
          },
        }),
      }),
      width: '120px',
      isShown: true,
    },
    {
      value: 'validFrom',
      name: 'valid_from',
      text: 'Valid from',
      width: '200px',
      isShown: true,
      customFilter: createDateFilter(),
    },
    {
      value: 'validTo',
      name: 'valid_to',
      text: 'Valid to',
      width: '200px',
      isShown: true,
      customFilter: createDateFilter(),
    },
    {
      text: 'Status',
      value: 'status',
      name: 'status',
      isHidden: true,
    },
    {
      value: 'actions',
      text: 'Actions',
      width: '60px',
      searchable: false,
      sortable: false,
      isShown: true,
      ...createCellActions({
        actionItems: (tableElement) => {
          const defaultActions = [
            {
              text: 'Archive',
              value: 'archivable',
              prop: 'archivable',
              callBack: (item, store) => {
                store.dispatch('privateOffers/archive', item.id);
              },
            },
            {
              text: 'Unarchive',
              value: 'unarchivable',
              prop: 'unarchivable',
              callBack: (item, store) => {
                store.dispatch('privateOffers/unarchive', item.id);
              },
            },
            {
              text: 'Complete',
              value: 'completable',
              prop: 'completable',
              callBack: (item, store) => {
                store.dispatch('privateOffers/complete', item.id);
              },
            },
            {
              text: 'Edit',
              value: 'editable',
              prop: 'editable',
              callBack: (item, store) => {
                store.dispatch('privateOffers/editorDialog/setPrivateOfferModal', {
                  id: item.id,
                  isShown: true,
                });
              },
            },
          ];
          const excluded = [];
          const filteredActions = defaultActions.filter(({ prop }) => {
            if (!prop) return true;

            return tableElement.actions[prop]
              ? tableElement.actions[prop]
              : false;
          });
          const finalActions = filteredActions.filter(({ value }) => !excluded.includes(value));

          return finalActions;
        },
      }),
    },
  ],
};
